import React from 'react';
import { useQueryWithStore, Loading, Error, SelectInput, DateInput, TextInput } from 'react-admin';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

const deferralCodes = [
    {
        id: 'ID',
        name: 'Indefinitely Deferred'
    },
    {
        id: 'N/A',
        name: 'Not applicable'
    },
    {
        id: 'PR',
        name: 'Permanently rejected'
    },
    {
        id : 'TD',
        name: 'Temporarly Deferred'
    }
  ]

const GetReferrals = ({ssn}) => {

   const { loaded, error, data } = useQueryWithStore({
        type: 'getOne',
        resource: 'donorbyssn',
        payload: { id: ssn }
    });

    if (!loaded) { return <Loading />; }
    if (error) { return <Error />; }
    return (
        <Table  style={{ margin: 'auto',  fontSize:'12px', cellspacing:"3", borderWidth:"1", width:"100%"}}  >
         <TableBody  >  
            <TableRow>
                <TableCell  align="left" ><SelectInput source="deferral_code"    label="Deferral code" choices={deferralCodes}   defaultValue={(data)?data.deferral_code: null}  /></TableCell>
                <TableCell  align="left" ><DateInput source="deferral_date"    label="Deferral date" locales="en-us"   defaultValue={(data)?data.deferral_date:null } /></TableCell>
                <TableCell  align="left" ><DateInput source="deferral_exp_date"    label="Deferral Exp date" locales="en-us" defaultValue={(data)?data.deferral_exp_date:null }   /></TableCell>
            </TableRow>
            <TableRow>
                <TableCell  align="left" colSpan="3"><TextInput source="deferral_comments"  rowsMax={4} multiline fullWidth  label="Deferral comments" defaultValue={(data)?data.deferral_comments:null} /></TableCell>
            </TableRow> 
        </TableBody>
    </Table>   
    )
};

export default GetReferrals;